module.exports = __webpack_public_path__ + "img/error.e057cd90.svg";